import React from 'react';
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom';
import {
    IonContent,
    IonIcon,
    IonLabel,
    IonRouterOutlet,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonLoading,
    IonToast,
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonSegment,
    IonSegmentButton,
    IonRow,
    IonCol,
    IonButton
} from '@ionic/react';
import { homeOutline, cartOutline, personOutline, cubeOutline, receiptOutline } from 'ionicons/icons';
import PosActions from '../../../actions/PosActions';
import Unidades from './Unidades';
import Categories from './Categories';
import Brands from './Brands';
import { getLoginApp } from '../../../utils/functions';
import Variations from './Variations';

interface IProps {
    setData_: any;
    get_: any;
    get_default: any;
}

interface IState {
    simpleToast: any;
    response: any;
    datalogin: any;
    loading: any;
    data_default: any;
    segmentActive: any;

}

class ConfigurationProduct extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props)
        this.state = {
            response: props.response,
            simpleToast: props.simpleToast,
            datalogin: props.datalogin,
            loading: props.loading,
            data_default: props.data_default,
            segmentActive: 1,

        }
    }

    componentDidMount() {
        this.props.get_default({
            typeOption: 'get_data_default',
            user_id: getLoginApp().id,
        }, "api/get_data_default");
        this.setState({
            segmentActive: '1'
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {

    }
    onDidDismissToast(e: any) {
        this.props.setData_({ response: {}, simpleToast: false });
    }



    render() {
        const { simpleToast, response, loading, segmentActive } = this.state;
        return (
            <IonPage>
                <IonHeader>
                    <IonToolbar color="primary">
                        <IonButtons slot="start">
                            <IonBackButton defaultHref="/home" text={""} />
                        </IonButtons>
                        <IonTitle>Configuración</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen scrollEvents={true} style={{ boderRadius: '10px' }}>
                    <IonLoading
                        //color="light"
                        cssClass='my-custom-class'
                        isOpen={!!(loading && loading.isOpen)}
                        message={`${loading && loading.Msg ? loading.Msg : ''}`}
                    />
                    {
                        response && response.Msg ? (
                            <IonToast
                                isOpen={!!simpleToast}
                                color={response && response.success === 1 ? 'success' : 'danger'}
                                position='top'
                                message={`${response && response.Msg ? response.Msg : ''}`}
                                duration={1500}
                                onDidDismiss={e => this.onDidDismissToast(e)}
                            />
                        ) : null
                    }
                    {

                        <IonSegment value={segmentActive} scrollable>
                            <IonSegmentButton
                                value="1"
                                onClick={() => {
                                    this.setState({
                                        segmentActive: '1'
                                    });
                                }}
                            >
                                <IonLabel>Unidades</IonLabel>
                            </IonSegmentButton>

                            <IonSegmentButton
                                value="2"
                                onClick={() => {
                                    this.setState({
                                        segmentActive: '2'
                                    });
                                }}
                            >
                                <IonLabel>Categorias</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton
                                value="3"
                                onClick={() => {
                                    this.setState({
                                        segmentActive: '3'
                                    });
                                }}
                            >
                                <IonLabel>Marcas</IonLabel>
                            </IonSegmentButton>
                            <IonSegmentButton
                                value="4"
                                onClick={() => {
                                    this.setState({
                                        segmentActive: '4'
                                    });
                                }}
                            >
                                <IonLabel>Variaciones</IonLabel>
                            </IonSegmentButton>
                        </IonSegment>

                    }
                    {
                        segmentActive == "1" ?
                            <>
                                <Unidades />
                            </>
                            :
                            null
                    }
                    {
                        segmentActive == "2" ?
                            <>
                                <Categories />
                            </>
                            :
                            null
                    }
                    {
                        segmentActive == "3" ?
                            <>
                                <Brands />
                            </>
                            :
                            null
                    }
                    {
                        segmentActive == "4" ?
                            <>
                                <Variations />
                            </>
                            :
                            null
                    }
                </IonContent>
            </IonPage>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data,

    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setData_: (data: any, name: string) => dispatch(PosActions.setData(data, name)),
        get_: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
        get_default: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigurationProduct);
